import { render } from "./MypageFolderPage.vue?vue&type=template&id=18fc51f2&scoped=true&ts=true"
import script from "./MypageFolderPage.vue?vue&type=script&lang=ts"
export * from "./MypageFolderPage.vue?vue&type=script&lang=ts"

import "./MypageFolderPage.vue?vue&type=style&index=0&id=18fc51f2&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fc51f2"]])

export default __exports__